import {DIALOG_ACTION} from "./types";

export const addDialog = dialog => ({type: DIALOG_ACTION.ADD, dialog});
export const dismissDialog = () => ({type: DIALOG_ACTION.DISMISS});